<template>
  <div class="award-header-section">
    <figure class="award-header-section__logo">
      <img :src="headerLogoPath" alt="" />
    </figure>
    <p class="award-header-section__link">
      <a :href="aboutAwardUrl" target="_blank" v-text="$i18n.tc('LinkPage.AwardPage.about')" />
    </p>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import Const from '@/util/Const'
import I18n from '@/locales/I18n'
import CloudFrontUtil from '@/util/aws/CloudFrontUtil'

/**
 * Award ヘッダー セクション
 */
export default defineComponent({
  name: 'AwardHeaderSection',
  props: {
    /**
     * 選択年
     */
    targetYear: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const aboutAwardUrl =
      I18n.locale === 'ja'
        ? Const.EXTERNAL_LINKS.ABOUT_AWARD.JA
        : Const.EXTERNAL_LINKS.ABOUT_AWARD.EN

    /** アワードヘッダーロゴのパス */
    const headerLogoPath = computed(() =>
      CloudFrontUtil.getSignedUrl(
        `${process.env.VUE_APP_IMG_FILE_PATH}/award/${props.targetYear}/sfgo_award_header_logo.png`,
      ),
    )

    return {
      aboutAwardUrl,
      headerLogoPath,
    }
  },
})
</script>

<style lang="scss" scoped>
.award-header-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
  width: 100%;
  padding: 40px 0 30px;

  &__logo {
    width: min(69.334vw, 260px);
    margin: 0 auto;

    img {
      filter: drop-shadow(0 0 150px rgba(0, 219, 166, 0.85));
      transform: translateZ(0);
    }
  }

  &__link {
    opacity: 0.8;

    a {
      display: inline-block;
      padding-bottom: 1px;
      color: $white70;
      font-family: $fontSignup;
      font-size: 12px;
      font-weight: 700;
      line-height: 1.66;
      letter-spacing: 0.02em;
      border-bottom: 1px solid rgba($white70, 0.35);
    }
  }
}
</style>
